import $ from "jquery";
import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="admission-nav"
export default class extends Controller {
  static targets = ["nav"];

  navLinkClick(event) {
    event.preventDefault();
    var href = event.currentTarget.getAttribute("href");
    var target = $(href === "#" || href === "" ? "html" : href);
    var eventHeader = $(".js-event-header").height(); // ヘッダーの高さを取得
    var nav = this.navTarget.offsetHeight; // ナビの高さを取得
    var speed = 1200;
    //クリックの際にカレントが消えないように少し余分に足す
    var position = target.offset().top - nav + 2;

    $.easing.quart = function (x, t, b, c, d) {
      return -c * ((t = t / d - 1) * t * t * t - 1) + b;
    };

    // ヘッダーの高さを考慮してpositionを計算
    if (position >= eventHeader) {
      position = position - eventHeader;
    }
    $("html, body").animate(
      {
        scrollTop: position,
      },
      speed,
      "quart",
    );
  }
}
